module.exports = __webpack_public_path__ + "img/map-marker-icon.98930f0b.png";